/*       */

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { RouterMatchPropTypeBuilder } from 'app/utils/propTypes/common';
import TeamsList from 'app/containers/Admin/Teams/TeamsList';
import TeamDetails from 'app/containers/Admin/Teams/Details/TeamDetails';
import PageNotAllowed from 'app/containers/ErrorPages/PageNotAllowed';

/**
 * Defines the routes for the Teams & Permissions views
 */
class TeamsRoute extends PureComponent {
    static propTypes = {
        match: RouterMatchPropTypeBuilder({ id: PropTypes.string }),
        userProfile: PropTypes.object,
    };

    /**
     * @override
     * Always make sure you use PageTemplate as PageContainer
     */
    render() {
        const { match } = this.props;
        const { permissions, isAdmin } = this.props.userProfile;
        const permissionsSet = new Set(permissions || []);
        const canView = isAdmin || permissionsSet.has('admin.team');
        if (!canView) {
            return <PageNotAllowed title="Teams" />;
        }
        return (
            <Fragment>
                <Switch>
                    <Route path={`${match.url}`} exact component={TeamsList} />
                    <Route path={`${match.url}/:id/about`} component={TeamDetails} />
                    <Route path={`${match.url}/:id/history`} exact component={TeamDetails} />
                    <Route path={`${match.url}/:id`} exact component={TeamDetails} />
                </Switch>
            </Fragment>
        );
    }
}

export default connect(state => ({
    userProfile: state.user.profile,
}))(TeamsRoute);
